export function initAnalytics() {
  if (import.meta.env.VITE_UMAMI_URL) {
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.dataset.websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
    script.src = import.meta.env.VITE_UMAMI_URL;
    document.head.appendChild(script);
  }
}
